export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-900 mb-2">
          联系我们
        </h2>
        <p className="text-sm text-foreground-600 mb-8">
          有建议或合作意向？欢迎通过以下方式与我们取得联系
        </p>

        <div className="rounded-2xl bg-background-50 p-6 md:p-10">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
            <div className="text-center">
              <span className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 mb-3">
                <i className="ri-mail-line text-xl text-primary-600"></i>
              </span>
              <div className="text-xs text-foreground-500 mb-1">电子邮箱</div>
              <div className="text-sm font-medium text-foreground-900">contact@meiridasai.com</div>
            </div>
            <div className="text-center">
              <span className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 mb-3">
                <i className="ri-wechat-line text-xl text-accent-600"></i>
              </span>
              <div className="text-xs text-foreground-500 mb-1">微信公众号</div>
              <div className="text-sm font-medium text-foreground-900">每日大赛入口</div>
            </div>
            <div className="text-center">
              <span className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-secondary-100 mb-3">
                <i className="ri-chat-3-line text-xl text-secondary-600"></i>
              </span>
              <div className="text-xs text-foreground-500 mb-1">在线反馈</div>
              <div className="text-sm font-medium text-foreground-900">站内留言板</div>
            </div>
          </div>

          <form className="text-left max-w-lg mx-auto" onSubmit={(e) => e.preventDefault()}>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-xs font-medium text-foreground-700 mb-1.5">称呼</label>
                <input
                  type="text"
                  name="name"
                  className="w-full px-3 py-2.5 rounded-lg text-sm bg-background-100 border border-background-200 text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                  placeholder="请输入您的称呼"
                />
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground-700 mb-1.5">邮箱</label>
                <input
                  type="email"
                  name="email"
                  className="w-full px-3 py-2.5 rounded-lg text-sm bg-background-100 border border-background-200 text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                  placeholder="请输入您的邮箱"
                />
              </div>
            </div>
            <div className="mb-4">
              <label className="block text-xs font-medium text-foreground-700 mb-1.5">留言内容</label>
              <textarea
                name="message"
                maxLength={500}
                rows={4}
                className="w-full px-3 py-2.5 rounded-lg text-sm bg-background-100 border border-background-200 text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                placeholder="请输入您的留言内容（500字以内）"
              ></textarea>
            </div>
            <input
              type="text"
              name="phone_alt"
              className="contact-form-alt-field"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
            />
            <button
              type="submit"
              className="w-full sm:w-auto px-6 py-3 rounded-lg bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              提交留言
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}